module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eddies Bastard")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epg"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("Just as the mightiest oak topples without its roots, so will a man without knowledge of his people come crashing to earth, dreamless and unfulfilled.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("We cannot hope to understand ourselves until we know something of those who have come before us.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("William A. Mann III "), _c('br'), _vm._v("from the Diary, c. 1885")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page09"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbd9568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eddiesbastard_epg.vue
// module id = 66
// module chunks = 0